import React from "react"
import { Link } from "gatsby"
import { makeStyles } from "@material-ui/core/styles"
import { withStyles } from "@material-ui/core/styles"
import _ from "lodash"
import { List, ListItem, Typography } from "@material-ui/core"

const styles = theme => ({
  ullist: {
    padding: 0,
  },
  listItem: {
    padding: 0,
  },
})

const MainMenuItem = ({ linkProps, classes }) => {
  return (
    <ListItem
      className={
        linkProps.isActive
          ? "nav-item " + " " + classes.listItem
          : "nav-item listItem" + " " + classes.listItem
      }
    >
      <Link
        className={classes.ullist + " " + "nav-link"}
        to={linkProps.path}
        {...linkProps.attributes}
        activeClassName={"active"}
      >
        <Typography component="span" className="feather-icon">
          {linkProps.icon}
        </Typography>
        <Typography component="span" className="nav-link-text">
          {linkProps.text}
        </Typography>
      </Link>
      {linkProps.isChildren ? (
        <SubMenu subLinkProps={linkProps.childItems} classes={classes} />
      ) : (
        ""
      )}
    </ListItem>
  )
}

const SubMenu = ({ subLinkProps, classes }) => {
  return (
    <>
      {!_.isEmpty(subLinkProps) ? (
        <List
          id="content_drp"
          className={
            classes.ullist + " " + "nav flex-column collapse collapse-level-1"
          }
        >
          {subLinkProps.map((linkProperties, i) => (
            <SubMenuItem linkProps={linkProperties} classes={classes} key={i} />
          ))}
        </List>
      ) : (
        console.log("sub menu items not find")
      )}
    </>
  )
}

export const SubMenuItem = ({ linkProps, classes }) => {
  return (
    <ListItem
      className={
        linkProps.isActive
          ? "nav-item " + " " + classes.listItem
          : "nav-item" + " " + classes.listItem
      }
    >
      <Link
        className={classes.ullist + " " + "nav-link"}
        to={linkProps.path}
        activeClassName={"active"}
      >
        {linkProps.text}
      </Link>
      {linkProps.isChildren ? (
        <SubMenu subLinkProps={linkProps.childItems} />
      ) : (
        ""
      )}
    </ListItem>
  )
}

export default withStyles(styles)(MainMenuItem)
